import React from "react";
import { ChevronDown } from "lucide-react";
import { faqs } from "./data";

/**
 * FaqSection — Preguntas frecuentes con <details>/<summary> nativos.
 */
export function FaqSection() {
  return (
    <section className="border-b border-gray-200 bg-brand-cream-soft" data-testid="landing-faq-section">
      <div className="container-prose py-20 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <p className="text-xs uppercase tracking-[0.22em] text-brand-coral font-semibold mb-3">Preguntas frecuentes</p>
          <h2 className="font-serif text-3xl sm:text-4xl text-gray-900 mb-4 leading-tight">
            Lo que abogados y entidades suelen preguntar.
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            ¿Tienes una duda específica?{" "}
            <a
              href="mailto:contacto@procure.justsapiens.com"
              className="text-brand-burgundy hover:text-brand-burgundy-light underline underline-offset-2"
            >
              Escríbenos
            </a>
            .
          </p>
        </div>
        <div className="md:col-span-8 space-y-3">
          {faqs.map((f, idx) => (
            <details
              key={idx}
              data-testid={`faq-item-${idx}`}
              className="group bg-white border border-gray-200 rounded-sm hover:border-brand-burgundy transition-colors"
            >
              <summary className="cursor-pointer list-none flex items-center justify-between p-5 font-serif text-base text-gray-900">
                <span>{f.q}</span>
                <ChevronDown
                  className="h-5 w-5 text-brand-burgundy shrink-0 transition-transform group-open:rotate-180"
                  aria-hidden="true"
                />
              </summary>
              <div className="px-5 pb-5 text-sm text-gray-700 leading-relaxed">{f.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
